import { Angle, AssetsManager, Axis, Collider, Color3, Mesh, MeshBuilder, ParticleHelper, ParticleSystem, PhysicsAggregate, PhysicsShapeType, Quaternion, Scene, SceneLoader, SolidParticleSystem, Space, StandardMaterial, TrailMesh, Vector3 } from "@babylonjs/core";
import snowParticlesBehind from "../../particles/snwoParticlesBehind.json"

let _skiMesh: Mesh | null = null;
export class Player {

  rg: PhysicsAggregate | null;
  mesh: Mesh
  playerMesh: Mesh
  beanie: Mesh
  //scarf: Mesh
  leftSki: Mesh | null = null
  rightSki: Mesh | null = null
  private isLeaning: boolean = false;
  snowParticles: ParticleSystem;
  skiTrailMat: StandardMaterial;
  leftSkiTrail: TrailMesh | null = null;
  rightSkiTrail: TrailMesh | null = null;
  scene: Scene;
  leftSkiTrailGenerator: Mesh | null = null;
  rightSkiTrailGenerator: Mesh | null = null;
  playerMat: StandardMaterial;
  isBreaking: boolean = false;

  constructor(scene: Scene, startPos: Vector3) {
    this.scene = scene;

    this.mesh = MeshBuilder.CreateBox("player", { size: 2 }, scene);
    this.mesh.isVisible = false
    this.mesh.position = startPos;

    this.playerMat = new StandardMaterial("playerMat");
    this.playerMat.emissiveColor = Color3.Black();
    this.playerMat.disableLighting = true;

    const blueMat = new StandardMaterial("blueMat");
    blueMat.emissiveColor = Color3.Blue();
    blueMat.disableLighting = true;

    this.playerMesh = MeshBuilder.CreateCapsule("player", { height: 2, radius: 0.5 }, scene);
    this.playerMesh.parent = this.mesh
    this.playerMesh.material = this.playerMat;
    this.playerMesh.position.y = 0.5

    const hoodieMesh = MeshBuilder.CreateCapsule("hoodie", { height: 2, radius: 0.52 }, scene);
    hoodieMesh.parent = this.playerMesh
    hoodieMesh.material = blueMat;
    hoodieMesh.position.y = 0.05

    const headMesh = MeshBuilder.CreateSphere("head", { diameter: 0.8 }, scene);
    headMesh.parent = this.playerMesh
    headMesh.material = this.playerMat;
    headMesh.position.y = 1.5


    this.beanie = MeshBuilder.CreateSphere("beanie", { diameter: 0.85 }, scene);
    this.beanie.parent = this.playerMesh
    this.beanie.position.y = 1.6
    this.beanie.material = blueMat;

    const rightHandMesh = MeshBuilder.CreateSphere("rightHand", { diameter: 0.3 }, scene);
    rightHandMesh.parent = this.playerMesh
    rightHandMesh.material = this.playerMat;
    rightHandMesh.position.y = 0.1
    rightHandMesh.position.x = 0.8

    const leftHandMesh = MeshBuilder.CreateSphere("leftHand", { diameter: 0.3 }, scene);
    leftHandMesh.parent = this.playerMesh
    leftHandMesh.material = this.playerMat;
    leftHandMesh.position.y = 0.1
    leftHandMesh.position.x = -0.8

    const rightPoleMesh = MeshBuilder.CreateCylinder("rightPole", { diameter: 0.1, height: 2 }, scene);
    rightPoleMesh.parent = rightHandMesh
    rightPoleMesh.material = blueMat;
    rightPoleMesh.position.y = -0.8

    const leftPoleMesh = MeshBuilder.CreateCylinder("leftPole", { diameter: 0.1, height: 2 }, scene);
    leftPoleMesh.parent = leftHandMesh
    leftPoleMesh.material = blueMat;
    leftPoleMesh.position.y = -0.8

    const rightPoleTipMesh = MeshBuilder.CreateCylinder("rightPoleTip", { diameter: 0.2, height: 0.05 }, scene);
    rightPoleTipMesh.parent = rightPoleMesh
    rightPoleTipMesh.material = this.playerMat;
    rightPoleTipMesh.position.y = -0.7

    const leftPoleTipMesh = MeshBuilder.CreateCylinder("leftPoleTip", { diameter: 0.2, height: 0.05 }, scene);
    leftPoleTipMesh.parent = leftPoleMesh
    leftPoleTipMesh.material = this.playerMat;
    leftPoleTipMesh.position.y = -0.7

    /*
    const scarfMat = new StandardMaterial("scarfMat");
    scarfMat.diffuseColor = Color3.Red();
    this.scarf = MeshBuilder.CreateRibbon("scarf", { : 1.6 }, scene);
    this.scarf.parent = this.playerMesh
    this.scarf.position.y = 0.8
    this.scarf.material = beanieMat;
    */

    this.skiTrailMat = new StandardMaterial("skiTrailMat", scene);
    this.skiTrailMat.diffuseColor = Color3.Black();
    this.skiTrailMat.specularColor = Color3.Black();
    this.skiTrailMat.alpha = 0.1

    // const particleSystem = ParticleHelper.CreateDefault(this.mesh);
    // const boxEmitter = particleSystem.createBoxEmitter(new Vector3(0, 0, 0), new Vector3(0, 0, -1), new Vector3(-1, -1, 0), new Vector3(1, 1, 0));
    // particleSystem.start();
    // particleSystem.blendMode = ParticleSystem.BLENDMODE_ADD;
    // particleSystem.minSize = 0.1;
    // particleSystem.maxSize = 3;

    // particleSystem.minLifeTime = 0.1;
    // particleSystem.maxLifeTime = 2;
    // particleSystem.isBillboardBased = false;

    // particleSystem.minEmitPower = 10;
    // particleSystem.maxEmitPower = 10;
    // particleSystem.emitRate = 100;
    // particleSystem.maxScaleX = 1
    // particleSystem.maxScaleY = 1
    // particleSystem.maxInitialRotation = Math.PI;
    // particleSystem.minInitialRotation = Math.PI;


    this.snowParticles = ParticleSystem.Parse(snowParticlesBehind, scene, "", false, 1000);
    const sphereSnowBehind = MeshBuilder.CreateSphere("sphereSnowBehind", { diameter: 1, segments: 2 }, scene);
    sphereSnowBehind.isVisible = false;
    sphereSnowBehind.position = new Vector3(0, this.mesh.position.y - 0.8, 0)
    this.snowParticles.emitter = sphereSnowBehind;
    this.snowParticles.stop();
    sphereSnowBehind.parent = this.mesh;


    // const speedTrail = new TrailMesh("speedTrail", this.mesh, scene, 0.05, 10, true);
    // const speedTrailMat = new StandardMaterial("speedTrailMat", scene);
    // speedTrailMat.emissiveColor = Color3.White();
    // speedTrailMat.diffuseColor = Color3.White();
    // speedTrailMat.specularColor = Color3.White();
    // speedTrailMat.alpha = 0.5
    // speedTrail.material = speedTrailMat
    // speedTrail.position = new Vector3(1)


    // Create a sphere shape and the associated body. Size will be determined automatically.
    this.rg = new PhysicsAggregate(this.mesh, PhysicsShapeType.SPHERE, { mass: 10, friction: 1000, restitution: -10000 }, scene);
    this.rg.body.setAngularDamping(100)
    this.rg.body.setLinearDamping(2)
  }

  async init(scene: Scene) {
    const skiMat = new StandardMaterial("skiMat");
    skiMat.diffuseColor = Color3.Blue();
    if (_skiMesh == null) {
      _skiMesh = (await SceneLoader.ImportMeshAsync("", "./models/", "ski.glb", scene)).meshes[0] as Mesh;
      console.log(_skiMesh)
      _skiMesh.name = "_ski";
      _skiMesh.isVisible = false;
      _skiMesh.getChildMeshes().forEach(mesh => mesh.isVisible = false);
    }

    this.leftSki = _skiMesh.clone("skiLeft");
    if ((this.leftSki.getChildren()[0] as Mesh)) (this.leftSki.getChildren()[0] as Mesh).material = skiMat;
    this.leftSki.parent = this.mesh
    this.leftSki.position.x = -0.5
    this.leftSki.position.y = -1
    this.leftSki.getChildMeshes().forEach(mesh => mesh.isVisible = true);

    this.leftSkiTrailGenerator = MeshBuilder.CreateBox("leftSkiTrailGenerator", { size: 0.1 }, scene);
    this.leftSkiTrailGenerator.parent = this.leftSki;
    this.leftSkiTrailGenerator.position.z = 1;
    this.leftSkiTrailGenerator.isVisible = false

    this.rightSki = _skiMesh.clone("skiRight");
    if ((this.rightSki.getChildren()[0] as Mesh)) (this.rightSki.getChildren()[0] as Mesh).material = skiMat;
    this.rightSki.parent = this.mesh
    this.rightSki.position.x = 0.5
    this.rightSki.position.y = -1
    this.rightSki.getChildMeshes().forEach(mesh => mesh.isVisible = true);

    this.rightSkiTrailGenerator = MeshBuilder.CreateBox("rightSkiTrailGenerator", { size: 0.1 }, scene);
    this.rightSkiTrailGenerator.parent = this.rightSki;
    this.rightSkiTrailGenerator.position.z = 1;
    this.rightSkiTrailGenerator.isVisible = false
  }

  public lean(value: boolean): void {
    this.isLeaning = value;
  }

  public unfreeze() {
    this.snowParticles.start();
  }

  public break(value: boolean) {
    this.isBreaking = value;
  }

  update() {

    // trail show/hide when in the air to make the effect that the skis leave a trace in the snow
    if (this.mesh.position.y <= 0.25) {
      if (this.leftSkiTrail == null) {
        this.leftSkiTrail = new TrailMesh("leftSkiTrail", this.leftSkiTrailGenerator!, this.scene, 0.15, 60, true);
        this.leftSkiTrail.material = this.skiTrailMat;
      }

      if (this.rightSkiTrail == null) {
        this.rightSkiTrail = new TrailMesh("rightSkiTrail", this.rightSkiTrailGenerator!, this.scene, 0.15, 60, true);
        this.rightSkiTrail.material = this.skiTrailMat
      }
    }
    else {
      if (this.leftSkiTrail != null) {
        this.leftSkiTrail.stop()
        this.leftSkiTrail = null
      }
      if (this.rightSkiTrail != null) {
        this.rightSkiTrail.stop();
        this.rightSkiTrail = null;
      }
    }

    // rotations and animations
    if (this.rg) {
      const sideRotation = Quaternion.RotationAxis(this.playerMesh.forward, Angle.FromDegrees(-this.rg.body.getLinearVelocity().x / 2).radians());
      const frontRotation = Quaternion.RotationAxis(this.playerMesh.right, Angle.FromDegrees((this.rg.body.getLinearVelocity().z / 2)).radians());
      this.playerMesh.rotation = new Vector3(Angle.FromDegrees(Math.min((this.isLeaning ? 45 : 0) + (this.rg.body.getLinearVelocity().z / 8), 90)).radians(), 0, Angle.FromDegrees(-this.rg.body.getLinearVelocity().x / 1.8).radians()); // = sideRotation.add(frontRotation); //new Vector3(sideRotation.x + frontRotation.x, sideRotation.y + frontRotation.y, sideRotation.z + frontRotation.z);
      this.leftSki!.rotation = Quaternion.RotationAxis(this.mesh.up, Angle.FromDegrees((this.isBreaking ? 10 : 0) + this.rg.body.getLinearVelocity().x / 2).radians()).toEulerAngles();
      this.rightSki!.rotation = Quaternion.RotationAxis(this.mesh.up, Angle.FromDegrees((this.isBreaking ? -10 : 0) + this.rg.body.getLinearVelocity().x / 2).radians()).toEulerAngles();

    }
  }

  setParticleRate(volume: number) {
    this.snowParticles.emitRate = volume * 200;
  }

  dispose = () => {
    this.mesh.physicsBody?.dispose()
    this.rg?.dispose()
    this.mesh.physicsBody = null
    this.rg = null
    // this.mesh.physicsBody!.disablePreStep = false
  }

  getSpeed = () => {
    return this.rg ? this.rg.body.getLinearVelocity().length() / 2 : 0
  }
}